import { socket } from '../api/config';
import { encodeString } from '../utils';

// INFO: Формат получения новых сообщений по подписке
const FULL_MESSAGE_FORMAT = `{
  message_id
  dialog_id
  timestamp
  timestamp_received
  is_read
  is_delivered
  content
  message_uuid
  sender {
    sender_id
    name
    picture_path
    type_id
  }
}`;

export default {
  getAllMessages: (dialogId) => {
    const query = JSON.stringify({
      message: `{
          messages(dialog_id: ${dialogId}) ${FULL_MESSAGE_FORMAT}
        }`,
      queryName: 'messages',
    });
    socket.emit('graphql', query);
  },
  sendMessage: (text, message_uuid, dialogId) => {
    const query = JSON.stringify({
      message: `mutation {
          message: addBuyerMessage(input: {text: "${encodeString(
            text,
          )}", message_uuid: "${
            message_uuid
          }", dialog_id: ${
            dialogId
          }}) ${FULL_MESSAGE_FORMAT}
        }`,
      // INFO: Ивент для подписки на новые сообщения (приходят по одному)
      queryName: 'addMessage',
    });
    socket.emit('graphql', query);
  },
  sendMessageWithFile: (text, urls, message_uuid, dialogId) => {
    const query = JSON.stringify({
      message: `mutation {
          message: addBuyerMessage(input: {text: "${encodeString(
            text,
          )}", message_uuid: "${message_uuid}", attachments: ${urls}, dialog_id: ${
            dialogId
          }}) ${FULL_MESSAGE_FORMAT}
        }`,
      queryName: 'addMessage',
    });
    socket.emit('graphql', query);
  },
  messageTyping: (isTyping, dialogId) => {
    socket.emit('typing', { isTyping, dialogId });
  },
  addBuyerChoice: ({ title, payload, messageUUID, userReply }, dialogId) => {
    const userReplyParam = userReply ? `, userReply: "${userReply}"` : '';
    const messageUUIDParam = messageUUID ? `, message_uuid: "${messageUUID}"` : '';
    const dialogIdParam = dialogId ? `, dialog_id: ${dialogId}` : '';

    const query = JSON.stringify({
      message: `mutation {
          message: addBuyerChoice(input: { 
            button: { title: "${title}", payload: "${payload}"${userReplyParam}}${messageUUIDParam}${dialogIdParam} }) 
              ${FULL_MESSAGE_FORMAT}
        }`,
      queryName: 'addMessage',
    });
    socket.emit('graphql', query);
  },
  addLocationChoice: (dialog_id, offer) => {
    const variables = {
      input: {
        dialog_id,
        offer,
      },
    };
    const query = {
      message: `mutation ($input: AddBuyerOfferChoiceInput) {
        message: addBuyerOfferChoice(input: $input) {
          message_id
          dialog_id
          timestamp
          timestamp_received
          is_read
          is_delivered
          content
          message_uuid
          sender {
            sender_id
            name
            picture_path
            type_id
          }
        }
      }`,
      variables,
      queryName: 'addMessage',
    };
    socket.emit('graphql', query);
  },
  rateExpert: (dialogId, expertId, buyerSenderId, score, messageId) => {
    const variables = {
      dialogId,
      buyerScore: {
        expertId,
        buyerSenderId,
        score,
        messageId,
      },
    };

    const query = {
      message: `mutation($dialogId: Int!, $buyerScore: BuyerScore) {
        message: saveBuyerScore(dialogId: $dialogId, buyerScore: $buyerScore) {
          scoreId
        }
      }`,
      variables,
      queryName: 'saveBuyerScore',
    };

    socket.emit('graphql', query);
  },
  saveFeedback: (dialogId, expertId, buyerSenderId, comment, messageId) => {
    const variables = {
      dialogId,
      buyerScoreComment: {
        expertId,
        buyerSenderId,
        comment,
        messageId,
      },
    };

    const query = {
      message: `mutation($dialogId: Int!, $buyerScoreComment: BuyerScoreComment) {
        message: saveBuyerScoreComment(dialogId: $dialogId, buyerScoreComment: $buyerScoreComment) {
          id
        }
      }`,
      variables,
      queryName: 'saveBuyerScoreComment',
    };

    socket.emit('graphql', query);
  },
  changeExpert: (dialogId, buyerId, reasonId, customReason) => {
    const variables = {
      dialogId,
      buyerId,
      reasonId,
      customReason,
    };

    const query = {
      message: `mutation($dialogId: Int!, $buyerId: Int!, $reasonId: Int!, $customReason: String) {
        message: changeExpert(dialogId: $dialogId, buyerId: $buyerId, reasonId: $reasonId, customReason: $customReason) {
          id
        }
      }`,
      variables,
      queryName: 'changeExpert',
    };

    socket.emit('graphql', query);
  },
  updateDialogMessages: (dialogId, senderId) => {
    const query = {
      message: `mutation ($dialogId: Int!, $senderId: Int!) {
        message: updateDialogMessages(dialogId: $dialogId, senderId: $senderId) {
          messageIds
        }
      }`,
      queryName: 'updateDialogMessages',
      variables: {
        dialogId,
        senderId,
      },
    };
    socket.emit('graphql', query);
  },
};
